import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0
    }
});
export default stylesheet;
